define([
	"domReady",
	"wcs.context",
	], function(domReady, context) {

	domReady(function() {

		// Log visitor user type and data
		try {
			var loggedIn 			= context.getUserType() == 'G'? false:true;
			var loyaltyOptInStatus 	= context.getLoyaltyOptIn() == '0'? false:true;
			var memberID			= context.getUserId();
			
			window.dataLayer = window.dataLayer || {};
			window.dataLayer.push({
				'user' : {
					'memberID' : loggedIn ? memberID:null,
					'loggedIn' : loggedIn,
					'loyaltyMember' : loggedIn ? loyaltyOptInStatus:false
				}
			});
		} catch (err) {
			console.error('Failed push to dataLayer',err);
		}
	});
});